import Phaser, {} from 'phaser'

//*** VARIABLES ***/
let gameScale;
let percentText;
let loadingText;
let tagText;
let callback;
let parent;
let _this;
let path = '././assets/images/';
let pathSounds = '././assets/sounds/';

let assetArray = [{
    id: 'flax1',
    path: path + 'flax1.svg'
  }, {
    id: 'flax2',
    path: path + 'flax2.svg'
  }, {
    id: 'redGrass',
    path: path + 'red-grass.svg'
  },
  {
    id: 'arrow',
    path: path + 'arrow.svg'
  },
  {
    id: 'worldBackgroundSky',
    path: path + 'world-background-sky.svg'
  }, {
    id: 'cloud1',
    path: path + 'cloud1.svg'
  }, {
    id: 'cloud2',
    path: path + 'cloud2.svg'
  }, {
    id: 'cloud3',
    path: path + 'cloud3.svg'
  }, {
    id: 'worldMidground2',
    path: path + 'midground2.svg'
  }, {
    id: 'worldMidground3',
    path: path + 'midground3.svg'
  }, {
    id: 'worldMidgroundHill1',
    path: path + 'hill1.svg'
  }, {
    id: 'worldMidgroundHill2',
    path: path + 'hill2.svg'
  }, {
    id: 'worldMidgroundHill3',
    path: path + 'hill3.svg'
  },
  {
    id: 'guide1',
    path: path + 'guide-1.svg'
  },
  {
    id: 'guideProfile',
    path: path + 'guide-profile.svg'
  },
  {
    id: 'guideArm',
    path: path + 'guide-arm.svg'
  },



  {
    id: 'speech',
    path: path + 'speech.svg'
  },

  {
    id: 'nextEnglish',
    path: path + 'next-english.svg'
  },
  {
    id: 'nextMaori',
    path: path + 'next-maori.svg'
  }, {
    id: 'backEnglish',
    path: path + 'back-english.svg'
  }, {
    id: 'backMaori',
    path: path + 'back-maori.svg'
  }, {
    id: 'navBGSkip',
    path: path + 'nav-bg-skip.svg'
  }, {
    id: 'navBGHome',
    path: path + 'nav-bg-home.svg'
  }, {
    id: 'skipEnglish',
    path: path + 'skip-english.svg'
  }, {
    id: 'skipMaori',
    path: path + 'skip-maori.svg'
  }, {
    id: 'homeEnglish',
    path: path + 'home-english.svg'
  }, {
    id: 'homeMaori',
    path: path + 'home-maori.svg'
  }, {
    id: 'languageEnglish',
    path: path + 'language-english.svg'
  }, {
    id: 'languageMaori',
    path: path + 'language-maori.svg'
  }, {
    id: 'soundEnglish',
    path: path + 'sound-english.svg'
  }, {
    id: 'soundMaori',
    path: path + 'sound-maori.svg'
  }, {
    id: 'soundOffEnglish',
    path: path + 'sound-english-off.svg'
  }, {
    id: 'soundOffMaori',
    path: path + 'sound-maori-off.svg'
  }, {
    id: 'matchBG',
    path: path + 'match-bg.svg'
  }, {
    id: 'matchEnglish',
    path: path + 'match-english.svg'
  }, {
    id: 'matchMaori',
    path: path + 'match-maori.svg'
  }, {
    id: 'closeEnglish',
    path: path + 'close-english.svg'
  }, {
    id: 'closeMaori',
    path: path + 'close-maori.svg'
  }, {
    id: 'cabbage2',
    path: path + 'cabbage-2.svg'
  }, {
    id: 'kawakawa',
    path: path + 'kawakawa.svg'
  }, {
    id: 'raupo',
    path: path + 'raupo.svg'
  }, {
    id: 'cabbage1',
    path: path + 'cabbage-1.svg'
  }, {
    id: 'wharenui',
    path: path + 'wharenui.svg'
  }, {
    id: 'manuka3',
    path: path + 'manuka-3.svg'
  }, {
    id: 'manuka2',
    path: path + 'manuka-2.svg'
  }, {
    id: 'cabbage3',
    path: path + 'cabbage-3.svg'
  }, {
    id: 'manuka1',
    path: path + 'manuka-1.svg'
  }, {
    id: 'sea',
    path: path + 'sea.svg'
  },
  {
    id: 'river',
    path: path + 'river.svg'
  },
  {
    id: 'hand',
    path: path + 'hand2.svg'
  },
  {
    id: 'auntyKewa',
    path: path + 'aunty-kewa.svg'
  },
  {
    id: 'flaxBundle',
    path: path + 'flax-bundle.svg'
  }, {
    id: 'kaumatuaPorch',
    path: path + 'kaumatua-porch.svg'
  }, {
    id: 'nana',
    path: path + 'nana.svg'
  }, {
    id: 'nanaUnder',
    path: path + 'nana-under.svg'
  }, {
    id: 'nanaBottom',
    path: path + 'nana-bottom.svg'
  },
  {
    id: 'porchStep',
    path: path + 'porch-step.svg'
  },
  {
    id: 'midGround3Sea',
    path: path + 'midground3-sea.svg'
  },
  {
    id: 'birdsong',
    path: pathSounds + 'bird-chorus.mp3'
  }, {
    id: 'click',
    path: pathSounds + 'pop3.mp3'
  }, {
    id: 'rustle',
    path: pathSounds + 'rustle5.mp3'
  }, {
    id: 'pop',
    path: pathSounds + 'click1.mp3'
  }, {
    id: 'swipe',
    path: pathSounds + 'swipe3.mp3'
  }, {
    id: 'right',
    path: pathSounds + 'right.mp3'
  }, {
    id: 'wrong',
    path: pathSounds + 'wrong.mp3'
  },


];

export default class Preloader extends Phaser.Scene {

  constructor() {
    super('preloader')
  }

  init() {
    // assetArray = arguments;
    _this = this;

    this.cameras.main.setBackgroundColor('rgba(0, 0, 0, 1)');
    this.events.on('wake', () => {
      this.cameras.main.fadeIn(100, 0, 0, 0);
    })
  }

  preload() {
    gameScale = this.registry.values.scaleIt;
    this.load.maxParallelDownloads = 10;
    this.startGraphics();
    this.loadIt(assetArray, this.startIt, this);

  }

  //This method is recalled by locations when they load
  loadIt(fileArray, f, context) {
    this.scene.wake('preloader');
    callback = f;
    parent = context;

    this.load.removeAllListeners();
    this.load.reset();

    this.scene.bringToTop('preloader');

    this.load.once('complete', this.ready, context);
    this.load.on('progress', this.updateProgress, this);
    /*this.load.on('fileprogress', function (file, value) {
      //console.log(file);
    });
*/

    let str;
    //go through file array, start at end of string, go back until find ".". Create a switch case, mp3, xml, svg etc
    for (let index = 0; index < fileArray.length; index++) {
      str = fileArray[index].path;
      // console.log("Preloader -> loadIt -> str", str)
      str = str.substring(str.lastIndexOf('.') + 1, str.length);

      switch (str) {
        case 'svg':
          // console.log(fileArray[index].path);
          this.load.svg(fileArray[index].id, fileArray[index].path, {
            scale: gameScale
          });
          break;
        case 'xml':
          this.load.xml(fileArray[index].id, fileArray[index].path);
          break;

        case 'mp3':
          this.load.audio(fileArray[index].id, fileArray[index].path);

          break;
        default:
          break;
      }

    }

    this.load.start();
    //was there anything to load?
    //console.log("Preloader -> loadIt -> this.load.isLoading()", this.load.isLoading())
    if (this.load.isLoading === false) {
      this.ready();
    }


  }


  startGraphics() {
    /* console.log(this.scale.canvasBounds.width);
     console.log(this.scale.canvas.style.width);
     console.log(this.game.config.parent);     
     console.log(this.game.canvas.width);
     */
    let _centerX = this.cameras.main.centerX; //this.scale.canvasBounds.width/2;
    let _centerY = this.cameras.main.centerY; //this.scale.canvasBounds.width/2;


    /*
    loadingText = this.make.text({
      text: 'Te Whata Raki',
      align: 'center',
      x: _centerX,
      y: _centerY,
      scale: gameScale,
      style: {
        font: '66pt chopinscript',
        fill: '#ffffff'
      }
    });*/
    loadingText = this.add.dom(_centerX, _centerY).createFromHTML("Te Whata Raki");
    loadingText.setOrigin(0.5, 0.5);
    loadingText.setClassName('preload');
    /*
    tagText = this.make.text({
      x: _centerX,
      y: _centerY,
      scale: gameScale,
      text: 'Mā te kimi ka kite, mā te kite ka mōhio, mā te mōhio ka mārama!\nSeek and discover, discover and know, know and become enlightened!',
      
      style: {
        font: '15pt Arial',
        fill: '#ffffff',
        
      }
    });*/
    tagText = this.add.dom(_centerX, _centerY).createFromHTML("Mā te kimi ka kite, mā te kite ka mōhio, mā te mōhio ka mārama!<br />Seek and discover, discover and know, know and become enlightened!");
    tagText.setOrigin(0.5, 0.5);

    tagText.setClassName('tag');
    /*percentText = this.make.text({
      x: _centerX,
      y: _centerY,
      text: '0%',
      align: 'center',
      scale: gameScale,
      style: {
        font: '35pt chopinscript',
        fill: '#ffffff'
      }
    });*/
    percentText = this.add.dom(_centerX, _centerY).createFromHTML("0%");
    percentText.setOrigin(0.5, 0.5);
    percentText.setClassName('percent');

    //percentText = this.add.dom(0, 0).createFromHTML('');

    //percentText.setOrigin(0.5, 0.5);
    //textStyle = domText.node.style;
    //textStyle.fontSize = fontSize + 'px';

    loadingText.y -= tagText.height + 20 * gameScale;
    percentText.y += tagText.height + 20 * gameScale;
    //tagText.setAlign('right');
  }


  updateProgress(value) {
    percentText.setText(Math.round(value * 100) + '%');

  }


  create() {

  }

  startIt() {
    _this.scene.launch('xmlLoader');
    _this.scene.launch('sounds');
    _this.scene.launch('world');
    _this.scene.launch('navigate');
    _this.scene.launch('menu');
    _this.scene.launch('guide');
  }




  ready() {
    _this.load.off('progress');
    _this.cameras.main.on(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, (cam, effect) => {})
    _this.scene.sendToBack('preloader');
    _this.scene.sleep('preloader');
    _this.cameras.main.fadeOut(100, 0, 0, 0)
    callback(parent);
    //this.events.emit('ready');
    //this.cameras.main.fadeOut(100, 0, 0, 0)


  }



}